export class NewLock {
	constructor(
		public TableId: number,
		public RecordId: number) {
	}
}